import { Action } from '@cgs/wge';

export enum SpinMode {
  Spin,
  ReSpin,
}

export interface IStartSlotActionProvider {
  getStartSlotAction(spinMode: SpinMode): Action;
}
